import { Button, ConfigProvider, Form, Input } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import m3_logo from "../assets/images/M3_Logo.svg";
import GradientButton from "../Components/Button/GradientButton";
import { forgotAwsPassword } from "../utils/AWS/awsPassword";
import toastMessage from "../utils/toastMessage";
import { LoadingOutlined } from "@ant-design/icons";

function ForgotPassword() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSendOtp = ({ email }) => {
    console.log(email, " = handleSendOtp");
    setLoading(true);
    localStorage.setItem("username", email);
    forgotAwsPassword(email, (err, msg) => {
      if (err) {
        toastMessage(err, "error");
      } else {
        toastMessage(msg, "success");
        Navigate("/password-reset-otp", { state: { email } });
      }
      setLoading(false);
    });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
            colorText: "white",
          },
          Form: {
            colorTextHeading: "white",
          },
        },
      }}
    >
      <div className="bg-darkJungleGreen h-screen flex justify-center items-center text-white">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black shadow-signupBoxShadow px-10 py-28 rounded-2xl space-y-5">
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            Reset Password
          </h1>
          <p>
            Enter your email to <br /> receive an OTP
          </p>
          <Form
            form={form}
            className=" text-white"
            // name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            // initialValues={{ remember: true }}
            onFinish={handleSendOtp}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Enter Your Email"
              name="email"
              style={{ color: "white" }}
              rules={[
                {
                  required: true,
                  message: "Please input your Email!",
                },
                {
                  type: "email",
                  message: "Please enter valid email",
                },
              ]}
            >
              <Input placeholder="mail@exemple.com" />
            </Form.Item>
            <Form.Item className="mb-0">
              <GradientButton
                // onClick={handleSendOtp}
                className="bg-signupSubmitBtn flex items-center w-full rounded-3xl"
                // type="primary"
                disabled={loading}
                type="submit"
              >
                <span>Send OTP</span>
                {loading && (
                  <span>
                    <LoadingOutlined style={{ color: "white", fontSize: 20 }} />
                  </span>
                )}
              </GradientButton>
            </Form.Item>
          </Form>
          {/* <p onClick={handleResendOtp}
            className="border-none w-full text-center text-lg font-bold bg-sandAgainBtn inline-block text-transparent bg-clip-text mt-5 hover:text-white cursor-pointer"
            // icon={<Google_original />}
          >
            Send Again
          </p> */}
        </div>
      </div>
    </ConfigProvider>
  );
}

export default ForgotPassword;
